import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

export async function generatePromoPDF({ count, receiptNo, promoName, customer }) {
  const pdfDoc = await PDFDocument.create();
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

  for (let i = 0; i < count; i++) {
    const width = 198; // ~70mm
    const height = 567; // ~200mm in points

    const page = pdfDoc.addPage([width, height]);

    page.drawText(` ${promoName || "RCS PROMO"}`, {
      x: 20,
      y: height - 40,
      size: 14,
      font,
      color: rgb(0, 0, 0),
    });

    page.drawText(`Receipt No: ${receiptNo}`, { x: 20, y: height - 65, size: 11, font });
    page.drawText(`TICKET #${i + 1}`, { x: 20, y: height - 85, size: 11, font });

    page.drawText(`Thank you for your purchase,`, { x: 20, y: height - 110, size: 10, font });
    page.drawText(`You have earned ${count} ticket(s)`, { x: 20, y: height - 125, size: 10, font });
    page.drawText(`Here are your details:`, { x: 20, y: height - 140, size: 10, font });

    // ✅ Replaced blanks with customer info
    page.drawText(`Name: ${customer?.name || "N/A"}`, { x: 20, y: height - 170, size: 10, font });
    page.drawText(`Phone No: ${customer?.phone || "N/A"}`, { x: 20, y: height - 190, size: 10, font });
    page.drawText(`Address: ${customer?.address || "N/A"}`, { x: 20, y: height - 210, size: 10, font });

    page.drawText(`GOOD LUCK!!`, {
      x: width / 2 - 40,
      y: height - 250,
      size: 12,
      font,
    });
  }

  const pdfBytes = await pdfDoc.save();
  return pdfBytes;
}
